module.exports = __webpack_public_path__ + "img/BUY & TRADE.67c45592.svg";